import React from 'react';
import { Col, Row } from 'react-bootstrap';
import './fichaVehiculo.css'

const CaracteristicasVehiculo = ({ caracteristica }) => {
    if (!caracteristica ) return null;

    const { Descripcion, Nombre, Imagen } = caracteristica;
    console.log("🚀 -> CaracteristicasVehiculo -> caracteristica", caracteristica)
    if (!Descripcion && !Nombre && !Imagen) return null;
    return (

        <Col xs={4} md={4} lg="auto" className={`mx-auto px-0 pb-4 pb-md-0 m-caracteristicas`}>
            <Row>
                <Col className="text-center mb-3">
                    {Imagen ? <img src={Imagen} className="caracteristicas-img caracteristicas-img-responsive" alt={Nombre} /> : <></> }
                </Col>
            </Row>
            <Row>
                <Col className="px-1">
                    <h5 className="text-center bold-text-hyundai f-responsive-12 mb-1" dangerouslySetInnerHTML={{ __html: Descripcion}}></h5>
                </Col>
            </Row>
            <Row>
                <Col className="text-center px-1">
                    <h6 className="parrafo-hyundai f-responsive-10 mb-md-5">{Nombre}</h6>
                </Col>
            </Row>
        </Col>

    )
};

export default CaracteristicasVehiculo;